import { useCart } from '../../context/CartContext'
import './SingleCourse.css'
import {formatCurrency} from '../../utility/formatCurrency'
import { useNavigate } from 'react-router-dom'

type SingleCourseProps = {
  id: number,
  name: string,
  description: string,
  price: number,
  image: string,
  details: string,
  category: string,
  instructor: { name: string }
  updatedAt: string,
}

const SingleCourse = (props: SingleCourseProps) => {

  const { getItemQuantity, addToCart} = useCart();

  const quantity = getItemQuantity(props.id);
  const navigate = useNavigate();
  const date= new Date(props.updatedAt).toLocaleDateString();

  
  const handleClick = () => { 
    addToCart(props.id)
    navigate('/cart')
  }

  return (
    <div className='Course-Container'>
      
      <div className='Course-Header'>
        <div className='Course-Details-Container'>
          <h1 className='Course-H1'>{props.name}</h1>
          <p className='Course-Details'>{props.description}</p>
          <div className='CourseCategory-Page'>
            <p className='CourseCategoryText'>{props.category}</p>
          </div>
          <p className='Course-para'>Created By {props.instructor.name}</p>
          <p className='Course-para'>Last Updated { date}</p>
        </div>
        <div className='Course-Content'>
          <img className='Course-Image' src={props.image} alt={props.name} />
          <p>{formatCurrency(props.price)}</p>
          {/*<button className="Add-Course-Btn" onClick={handleClick}>Add Course</button>*/}
        </div>
        
      </div>
      
      
      
      
      
    </div>
  )
}

export default SingleCourse;